import React, { useState, useEffect, useRef } from "react";
import "./phoneCarousel.css";

const screenshots = [
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/bookingModalScreenshots.png",
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/calendarScreenshot.png",
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/editShopScreenshots.png",
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/shopScreenshots.png",
];

const PhoneCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);
    const touchStartX = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => goTo((currentIndex + 1) % screenshots.length), 5000);
        return () => clearInterval(interval);
    }, [currentIndex]);

    const goTo = (index) => {
        setFade(false);
        setTimeout(() => {
            setCurrentIndex(index);
            setFade(true);
        }, 200);
    };

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        if (touchStartX.current === null) return;
        const diff = touchStartX.current - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
            diff > 0
                ? goTo((currentIndex + 1) % screenshots.length)
                : goTo((currentIndex - 1 + screenshots.length) % screenshots.length);
        }
        touchStartX.current = null;
    };

    return (
        <div className="sf-phone-carousel" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
            <img
                src={screenshots[currentIndex]}
                alt="app preview"
                className={`sf-phone-image ${fade ? "fade-in" : "fade-out"}`}
            />
            <div className="sf-phone-dots">
                {screenshots.map((_, i) => (
                    <button
                        key={i}
                        className={`sf-phone-dot ${i === currentIndex ? "active" : ""}`}
                        onClick={() => goTo(i)}
                    />
                ))}
            </div>
        </div>
    );
};

export default PhoneCarousel;